import { PopupIds } from '../constants/PopupIds';
import '../vendor/jquery.scrollbar-0.2.10';
import {hideClientAndShowPopup, hidePopupsAndShowClient} from '../general/modules/popupFunctions';
import {sendSupportTicket} from './sendSupportTicket';
import {Localization} from '../localization/localization';
import { SupportTicketRequestData } from "./support-ticket-request-data";

let ticketInProgress = false;

function onOpenSupportButtonClick() {
    hidePopupsAndShowClient();
    hideClientAndShowPopup(PopupIds.SUPPORT_TICKET);
}

function onCloseSupportSuccessButtonClick() {
    hidePopupsAndShowClient();
}

function onCloseSupportButtonClick() {
    const supportTicket = $('#support_ticket_mobile');
    hidePopupsAndShowClient();

    $('.support_ticket_error', supportTicket).hide();
}

function onCustomSelectClick() {
    console.log('clicked');
    const supportTicket = $('#support_ticket_mobile');
    const customOptions = supportTicket.find('.options');

    if (customOptions.attr('data-expanded') === 'false') {
        customOptions.slideDown(function() {
            customOptions.attr('data-expanded', 'true');
        });
    } else {
        customOptions.slideUp(function() {
            customOptions.attr('data-expanded', 'false');
        });
    }
}

function onCustomSelectOptionClick(e: JQuery.Event) {
    const supportTicket = $('#support_ticket_mobile');
    e.stopPropagation();
    supportTicket.find('select option').text($(this).data('value'));
    supportTicket.find('.chosen').text($(this).text());
    supportTicket.find('.options').slideUp(function() {
        supportTicket.find('.options')
            .attr(
                'data-expanded',
                'false'
            );
    });
}

function getSupportRequestData(): SupportTicketRequestData {
    const supportTicket = $('#support_ticket_mobile');

    const user = window.app.user;
    return {
        subject: $('#support_ticket_subject', supportTicket).val(),
        body: $('#support_ticket_body').val(),
        type: $('#support_ticket_type', supportTicket).text(),
        email: $('#support_ticket_email', supportTicket).val(),
        browser: window.app.config.user_browser,
        ua: window.app.config.user_agent,
        hasPayment: user?.hasPayment ?? false,
        nickname: user?.gameNickname ?? '',
        donateAmount: user?.donate ?? 0,
        language: window.app.config.language,
        uid: '',
        network: window?.app?.config?.current_entry_point ?? 'N/A',
        realm: window.app.config.user_realm
    };
}

async function onSupportFormSubmit(e: JQuery.SubmitEvent) {
    e.preventDefault();

    if (ticketInProgress) {
        return;
    }

    const supportTicket = $('#support_ticket_mobile');

    ticketInProgress = true;
    const data = getSupportRequestData();


    const error = supportTicket.find('.support_ticket_error');
    let result: string | boolean;
    try {
        result = await sendSupportTicket(data);
    } catch (e) {
        console.error(error);
        error.text(Localization._n('support.common')).show();
        return;
    } finally {
        ticketInProgress = false;
    }

    if (result === true) {
        error.hide();
        supportTicket.find('input').val('');
        supportTicket.find('textarea').val('');
        supportTicket.hide();
        hidePopupsAndShowClient();
        hideClientAndShowPopup(PopupIds.SUPPORT_SUCCESS);
    } else {
        error.text(Localization._n('support.common')).show();
    }
}

function onAnywhereClickWhileCustomSelectOpened() {
    const supportTicket = $('#support_ticket_mobile');

    const customOptions = supportTicket.find('.options');
    if (customOptions.attr('data-expanded') === 'true') {
        customOptions.slideUp(function() {
            customOptions.attr('data-expanded', 'false');
        });
    }
}

function onDocumentReady() {
    console.log('support window mobile');
    const supportTicket = $('#support_ticket_mobile');

    $('#support_button').on('click', onOpenSupportButtonClick);
    $('#support_success .js-close-button,#support_success .support_but').on('click', onCloseSupportSuccessButtonClick);

    // @ts-ignore
    $('#support_ticket_body.scrollbar-rail').scrollbar();
    supportTicket.find('.js-close-button').on('click', onCloseSupportButtonClick);
    $(document).on('click', onAnywhereClickWhileCustomSelectOpened);
    supportTicket.find('.select').on('click', onCustomSelectClick);
    supportTicket.find('.option').on('click', onCustomSelectOptionClick);
    supportTicket.find('form').on('submit', onSupportFormSubmit);
}

$(onDocumentReady);
